import { useFeatureFlags } from "../feature-flags";
import { SchematicLayoutEngine } from "./layout-engine";
import { LegacyCableRouter } from "./legacy-router";
import { OrthogonalCableRouter } from "./orthogonal-router";
import type { CableRouter, CableRouterId } from "./types";

const routers: Record<CableRouterId, CableRouter> = {
  legacy: new LegacyCableRouter(),
  orthogonal: new OrthogonalCableRouter(),
};

/** The only feature-selection boundary. Consumers depend on CableRouter. */
export function cableRouterFor(experimental: boolean): CableRouter {
  return routers[experimental ? "orthogonal" : "legacy"];
}

export function getCableRouter(): CableRouter {
  return cableRouterFor(useFeatureFlags.getState().flags.orthogonalCableRouter);
}

const engines = new Map<CableRouter, SchematicLayoutEngine>();

export function getLayoutEngine(): SchematicLayoutEngine {
  const router = getCableRouter();
  let engine = engines.get(router);
  if (!engine) {
    engine = new SchematicLayoutEngine(router);
    engines.set(router, engine);
  }
  return engine;
}
